import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 20\" id=\"icon-chevron-left\"><path fill=\"currentColor\" d=\"M1.445 10L10 18.534V20L0 10 10 0v1.465z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol